import React, { FC, memo } from 'react';

import { DATA_TEST_IDS } from '../../consts';
import PromoOptionsList from '../PromoOptionsList';
import PromoSelectionHeader from '../PromoSelectionHeader';
import PromoSelectorSearchRow from '../PromoSelectorSearchRow';
import type { PromoSelectorDropdownProps } from '../types';

import styles from './index.module.scss';

const PromoSelectorDropdown: FC<PromoSelectorDropdownProps> = ({
  dropdownId,
  dropdownStyle,
  hasMoreItems,
  isLoadingMore,
  items,
  selectedCount,
  selectedPromoIdSet,
  onLoadMore,
  onPromoPlaybackToggle,
  onPromoSelectionChange,
  onReset,
}) => (
  <div
    id={dropdownId}
    className={styles.dropdown}
    data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_DROPDOWN}
    style={dropdownStyle}>
    <PromoSelectorSearchRow />
    <div
      className={styles.divider}
      data-testid={DATA_TEST_IDS.AUDIO_REPORT_PROMOS_DIVIDER}
    />
    <PromoSelectionHeader
      selectedCount={selectedCount}
      onReset={onReset}
    />
    <PromoOptionsList
      hasMoreItems={hasMoreItems}
      isLoadingMore={isLoadingMore}
      items={items}
      selectedPromoIdSet={selectedPromoIdSet}
      onLoadMore={onLoadMore}
      onPromoPlaybackToggle={onPromoPlaybackToggle}
      onPromoSelectionChange={onPromoSelectionChange}
    />
  </div>
);

export default memo(PromoSelectorDropdown);
